import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import KTFormInput from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import AppColors from 'general/constants/AppColors';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';

DialogChangeRfidCardView.propTypes = {
  vehicle: PropTypes.object,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogChangeRfidCardView({ vehicle, onCancel, onDone }) {
  // MARK: ---- PROPERTIES ----
  const [loading, setLoading] = useState(false);
  const [readyToValidate, setReadyToValidate] = useState(false);
  const [currentRfidCard, setCurrentRfidCard] = useState(null);
  useEffect(() => {
    if (vehicle?.cards?.length > 0) {
      setCurrentRfidCard(vehicle?.cards[0]);
    }
  }, [vehicle]);
  const [selectRfidCard, setSelectRfidCard] = useState(null);
  const dropdownRfidEl = useMemo(() => {
    return (
      <CustomDropdown2
        id="rfidCardId"
        name="rfidCardId"
        ignoreConfirmClick={true}
        toggleElement={
          <button
            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${
              !selectRfidCard && readyToValidate ? 'button-invalid' : ''
            }`}
            type="button"
          >
            {selectRfidCard?.name ?? 'Chọn thẻ RFID'}
          </button>
        }
        selectedValue={selectRfidCard}
        dropdownMenuItems={[{ name: 'RFID Card', role: 'RFID_CARD' }]}
        getSubItems={async (item) => {
          return ChargeHelper.API.RFID.requestGetRFIDCardList({
            page: item?.page || 0,
            limit: 10,
            q: item?.q || '',
            status: ChargeConstants.RFIDCardStatus.NORMAL,
            vehicleId: null,
          }).then((data) => {
            return {
              values: data.chargeRFIDs?.map((row) => ({
                id: row?.rfidId,
                name: row?.idTag,
                item: row,
              })),
              total: data.total,
            };
          });
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        onChange={(value) => {
          setSelectRfidCard(value);
        }}
        isDropdownForm={true}
        titleSearchable={true}
        searchable={true}
        searchFormClassName="mx-3 my-1 search-form-border"
        defaultValue={{
          name: 'RFID Card',
          role: 'RFID_CARD',
        }}
        footerEl={
          <div
            className="p-4 position-sticky sticky-bottom bg-white"
            style={{
              borderTop: `1px solid ${AppColors.gray[300]}`,
            }}
          >
            {UIHelper.buildNegativeButton('Bỏ chọn', () => {
              setSelectRfidCard(null);
              setReadyToValidate(false);
            })}
          </div>
        }
      />
    );
  }, [selectRfidCard, readyToValidate]);

  // MARK: ---- METHODS ----
  const handleSubmit = async () => {
    setReadyToValidate(true);
    if (!selectRfidCard) {
      ToastHelper.showError('Vui lòng chọn thẻ RFID mới');
      return;
    }
    if (selectRfidCard?.id === currentRfidCard?.rfidId) {
      ToastHelper.showError('Thẻ RFID mới không được trùng với thẻ RFID hiện tại');
      return;
    }
    const param = {
      vehicleId: vehicle?.vehicleId,
    };
    setLoading(true);
    const res = await ChargeHelper.API.RFID.requestUpdateRFIDCard(selectRfidCard?.id, param);
    setLoading(false);
    if (_.isBoolean(res) && res) {
      // cap nhat the RFID cu
      await ChargeHelper.API.RFID.requestUpdateRFIDCard(currentRfidCard?.rfidId, {
        vehicleId: null,
      });
      ToastHelper.showSuccess('Đổi thẻ RFID thành công');
      if (onDone) {
        onDone();
      }
    } else if (_.isString(res)) {
      ToastHelper.showError(res);
    }
  };

  return (
    <div>
      <div className="row m-0 p-0 px-2">
        {currentRfidCard && (
          <div className="col-12 mb-4 px-2">
            {UIHelper.buildFormLabel('Thẻ RFID hiện tại', true)}
            <KTFormInput name="currentRfidCard" value={currentRfidCard?.idTag} disabled />
          </div>
        )}

        <div className="col-12 mb-4 px-2">
          {UIHelper.buildFormLabel(currentRfidCard ? 'Chọn thẻ RFID mới' : 'Chon thẻ RFID', true)}
          {dropdownRfidEl}
        </div>
      </div>

      {/* footer */}
      <div
        className="d-flex align-items-center justify-content-end gap-3 p-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Bỏ qua', onCancel, null, true)}
        {UIHelper.buildGreenButton(
          currentRfidCard ? 'Đổi thẻ' : 'Xác nhận',
          handleSubmit,
          null,
          true,
          loading
        )}
      </div>
    </div>
  );
}

export default DialogChangeRfidCardView;
